import React from "react";
import TwoPie from "charts/TwoPie";

const data = [
  { name: "男性", value: 4813 },
  { name: "女性", value: 5187 }
];

const Sexy: React.FC = () => {
  return <TwoPie data={data} />;
};

export default Sexy;
